import React from 'react';
import { Row, Col, Form, ButtonGroup, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ColumnSchema } from '../../types/customReport';

interface Props {
  columns: ColumnSchema[];
  sortBy?: string;
  sortDir: 'asc' | 'desc';
  groupBy?: string;
  supportsGrouping: boolean;
  onChange: (sortBy?: string, sortDir?: 'asc' | 'desc', groupBy?: string) => void;
}

export const SortGroupPanel: React.FC<Props> = ({
  columns,
  sortBy,
  sortDir,
  groupBy,
  supportsGrouping,
  onChange,
}) => {
  const { t } = useTranslation('pages');

  const sortableColumns = columns.filter((c) => c.sortable);
  const groupableColumns = columns.filter((c) => c.groupable);

  return (
    <Row>
      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ fontSize: '0.85rem', fontWeight: 500 }}>{t('customReports.sortBy')}</Form.Label>
          <Form.Select
            size="sm"
            value={sortBy || ''}
            onChange={(e) => onChange(e.target.value || undefined, sortDir, groupBy)}
          >
            <option value="">{t('customReports.none')}</option>
            {sortableColumns.map((col) => (
              <option key={col.key} value={col.key}>
                {col.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      <Col md={4}>
        <Form.Group>
          <Form.Label style={{ fontSize: '0.85rem', fontWeight: 500 }}>{t('customReports.sortDirection')}</Form.Label>
          <div className="d-block">
            <ButtonGroup size="sm">
              <Button
                variant={sortDir === 'asc' ? 'primary' : 'outline-primary'}
                onClick={() => onChange(sortBy, 'asc', groupBy)}
              >
                {t('customReports.ascending')}
              </Button>
              <Button
                variant={sortDir === 'desc' ? 'primary' : 'outline-primary'}
                onClick={() => onChange(sortBy, 'desc', groupBy)}
              >
                {t('customReports.descending')}
              </Button>
            </ButtonGroup>
          </div>
        </Form.Group>
      </Col>

      {supportsGrouping && (
        <Col md={4}>
          <Form.Group>
            <Form.Label style={{ fontSize: '0.85rem', fontWeight: 500 }}>{t('customReports.groupBy')}</Form.Label>
            <Form.Select
              size="sm"
              value={groupBy || ''}
              onChange={(e) => onChange(sortBy, sortDir, e.target.value || undefined)}
            >
              <option value="">{t('customReports.none')}</option>
              {groupableColumns.map((col) => (
                <option key={col.key} value={col.key}>
                  {col.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}
    </Row>
  );
};

export default SortGroupPanel;
